import {
  useGetAncestorFoldersQuery,
  useGetProjectNameQuery,
} from '@frameio/graphql-client/generated';
import { Box, Text, theme } from '@frameio/vapor';
import { IconFolderClosed } from '@frameio/vapor-icons';
import { DotSeparator } from '../DotSeparator';

/**
 * Utilize this component if you already have the project/folder
 * information required.
 */
export function CrustcrumbsView({ projectName, folderName, isAtRoot }) {
  return (
    <Box
      display="flex"
      paddingTop={2}
      style={{
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }}
    >
      <Text
        color="secondary"
        enableTooltip={true}
        truncate={true}
        variant="secondary"
      >
        {projectName}
      </Text>
      {!isAtRoot && (
        <>
          <DotSeparator />
          <IconFolderClosed
            color={theme.colors.icon.secondary}
            size={16}
            style={{ flexShrink: 0, marginRight: '2px', marginLeft: '-2px' }}
          />
          <Text
            color="tertiary"
            enableTooltip={true}
            truncate={true}
            variant="secondary"
          >
            {folderName}
          </Text>
        </>
      )}
    </Box>
  );
}

/**
 * Returns a CrustCrumb (breadcrumb) of just the project and parent folder.
 * @param folderId
 * @returns CrustCrumbsView rendered
 */
export function Crustcrumbs({ folderId }: { folderId: string }) {
  const { data: assetData } = useGetAncestorFoldersQuery({
    variables: {
      assetId: folderId,
    },
    skip: !folderId,
  });

  const { data: projectData } = useGetProjectNameQuery({
    variables: {
      projectId: assetData?.account?.asset?.project?.id,
    },
    skip: !assetData?.account?.asset?.project?.id,
  });

  const crustcrumbsReady =
    Boolean(assetData?.account?.asset) &&
    Boolean(projectData?.account?.project);
  if (!crustcrumbsReady) return null;

  const projectName = projectData?.account?.project?.name;

  const folderName = assetData?.account?.asset?.name;

  const isAtRoot = !assetData?.account?.asset?.parent;

  return (
    <CrustcrumbsView
      folderName={folderName}
      isAtRoot={isAtRoot}
      projectName={projectName}
    />
  );
}
